export const STRETCHING_ANIMALS = ['snuffleupagus', 'cat', 'giraffe'];

export const VO_MAP = {
  intro: ['NFC_5.0_84'],
  select_prompt: ['NFC_7.0_107', 'NFC_5.0_92'],
  select_cat: ['NFC_7.0_131'],
  select_giraffe: ['NFC_7.0_132'],
  select_snuffleupagus: ['NFC_7.0_133'],
  stretch_start_cat: ['NFC_5.0_86', 'NFC_5.0_89'],
  stretch_start_giraffe: ['NFC_5.0_86', 'NFC_5.0_87'],
  stretch_start_snuffleupagus: ['NFC_5.0_86', 'NFC_5.0_88'],
  swipe_prompt: 'NFC_5.0_86.1',
  copy_prompt: ['NFC_5.0_86.2'],
  complete: ['NFC_6.0_97'],
};
